<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-18 09:32:49
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-21 19:25:51
 * @FilePath: /privacy-web/src/components/The/TheScroll.vue
-->
<template>
  <div id="scroll-content" class="scroll-content">
    <slot> </slot>
  </div>
</template>
<script>
export default {
  name: "TheScroll",
  data() {
    return {
      timer: null,
    };
  },
  props: {
    list: {
      type: Array,
      default: () => {},
    },
    i: {
      type: Number,
      default: 1,
    },
  },
  mounted() {
    this.scrollInit();
  },
  methods: {
    scrollInit() {
      const scrollDiv = document.getElementById("scroll-content");
      var that = this;
      var isFirefox = /Firefox/i.test(navigator.userAgent); //判断是不是火狐浏览器
      var mwEvent = !isFirefox ? "mousewheel" : "DOMMouseScroll";
      scrollDiv.addEventListener(mwEvent, this.mouseWheel, true);
    },
    mouseWheel(e) {
      if (this.timer) return;
      if (e.wheelDelta || e.detail) {
        if (e.wheelDelta > 0 || e.detail < 0) {
          //当鼠标滚轮向上滚动时
          // console.log('向上');
          if (this.i === 1) return;
          this.$emit("changeI", this.i - 1);
        }
        if (e.wheelDelta < 0 || e.detail > 0) {
          //当鼠标滚轮向下滚动时
          // console.log('向下');
          if (this.i === this.list.length) return;
          this.$emit("changeI", this.i + 1);
        }
      }
      this.timer = setTimeout(() => {
        clearTimeout(this.timer);
        this.timer = null;
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-content {
  height: 100%;
  background: #fff;
  overflow: auto;
}
</style>
